import { createReducer, on } from '@ngrx/store';
import {
  refreshUserInformation,
  refreshUserInformationFailure,
  refreshUserInformationSuccess,
  resetUserInformation,
} from './auth.actions';
import { initialAuthState } from './auth.state';

export const _authReducer = createReducer(
  initialAuthState,
  on(refreshUserInformation, (state) => ({
    ...state,
    isLoading: true,
  })),
  on(refreshUserInformationSuccess, (state, action) => ({
    ...state,
    // userInformation:
    //   (environment as any).isExternal === true
    //     ? {
    //         ...action.payload,
    //         roles: [
    //           // Permission.ONBOARDING_FRONT_OFFICE,
    //           // Permission.OPERATIONS_ONBOARDING,
    //           Permission.ONBOARDING_IFA,
    //           Permission.CLIENT,
    //           Permission.PORTFOLIO_MANAGER,
    //           Permission.ADMIN,
    //         ],
    //       }
    //     : action.payload,
    userInformation: action.payload,
    isLoading: false,
  })),
  on(refreshUserInformationFailure, (state) => ({
    ...state,
    isLoading: false,
  })),
  on(resetUserInformation, (state, action) => ({
    ...state,
    userInformation: null as any,
    token: null as any,
    isLoading: false,
  })),
);

export function authReducer(state: any, action: any) {
  return _authReducer(state, action);
}
